module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-be.c71d8412.png";